<template>
  <main class="mt-5">
    <div class="card mt-3">
      <div class="card-header border-0">
        <h5 class="card-title font-bold py-3">ثبت خرید</h5>
        <div style="flex: 1"></div>
        <Back url="/admin/shop" />
      </div>
      <div class="card-body">
        <form @submit.prevent="submit">
          <b-form-group v-show="hasPermission('write_created_at_in_mini_orders') ? true : false
            " class="col-md-6" label="زمان ثبت">
            <date-picker type="datetime" v-model="created_at" :format="'YYYY-MM-DD HH:mm'"
              :display-format="'jYYYY-jMM-jDD HH:mm'" />
          </b-form-group>
          <b-form-group label="انتخاب مشتری">
            <div class="d-flex col-md-6 mb-3" style="gap: 0.5rem">
              <b-form-input @keypress.enter.prevent="requestCustomer" v-model="customerMobile"
                :disabled="disabled || customerInfo" @input="requestCustomer" type="text" />
              <button @click="clearCustomer" v-if="customerInfo" class="btn btn-danger">
                لغو مشتری
              </button>
              <button v-if="customerInfo" type="button" id="sendCoupen" class="btn" :class="{
                'btn-light': !sendCoupenStatus,
                btnprimary: sendCoupenStatus,
              }" @click="sendCoupenStatus = !sendCoupenStatus">
                <strong> ارسال کد تخفیف </strong>
                <input v-model="sendCoupenStatus" type="checkbox" />
              </button>
            </div>
            <template v-if="customerInfo">
              <div v-if="customerInfo.customer" class="row">
                <div v-for="i in [['حضوری', 'physical']]" :key="i[1]" class="col-6 d-flex justify-content-between px-3">
                  <div>
                    شارژ کیف پول:
                    <span v-if="customerInfo.customer" class="font-weight-bold">{{
                      customerInfo.customer.wallet.balance | price
                    }}
                      تومان</span>
                  </div>
                  <div>
                    میزان خرید:
                    <span class="font-weight-bold">
                      {{ customerInfo[i[1]].orders_total }}</span>
                  </div>
                  <div>
                    میزان خرید:
                    <span class="font-weight-bold">
                      {{ customerInfo[i[1]].orders_total }}</span>
                  </div>
                </div>
              </div>
              <div class="col-12 font-weight-bold" v-else>مشتری جدید</div>
            </template>
          </b-form-group>
          <div class="row">
            <b-form-group class="col-md-6" label="نام">
              <b-form-input type="text" v-model="firstName" />
            </b-form-group>
            <b-form-group class="col-md-6" label="نام خانوادگی">
              <b-form-input type="text" v-model="lastName" />
            </b-form-group>
          </div>
          <b-form-group label="انتخاب محصول">
            <div class="d-flex col-md-6" style="gap: 0.5rem">
              <b-form-input autocomplete="off" autofocus ref="productSku" v-model="productSku" :disabled="disabled"
                @keypress.prevent.enter="requestProduct" type="text" />
              <div class="d-flex mr-3" style="gap: 0.6rem">
                <label for="refund_checkbox">مرجوعی</label>
                <b-form-checkbox id="refund_checkbox" type="checkbox" :disabled="disabled" v-model="refund" />
              </div>
            </div>
          </b-form-group>
          <b-form-group label="جستجوی محصول" class="mb-5">
            <ProductSearch ref="productSearch" :selectable="true" class="row mb-5" :physicalQuantity="true"
              :show-label="false" @selectVariety="selectVariety" />
          </b-form-group>
          <div v-for="i in ['varieties', 'refund_varieties']" v-if="$data[i] != ''">
            <template>
              <h4 class="table-title">
                <template v-if="i === 'varieties'">فروش</template>
                <template v-else>مرجوع</template>
              </h4>
            </template>
            <b-table class="mt-3 admin-order" :key="hasSelectedItem ? 'with-wallet' : 'without-wallet'"
              :class="$data[i]" hover bordered responsive :items="$data[i]" :fields="getFields(i)">
              <template v-slot:cell(index)="data">
                <span :class="{ active: data.item.has_relation_with_category_9 }">
                  {{ data.index + 1 }}
                </span>
              </template>
              <template v-slot:cell(image)="data" class="text-center">
                <div class="order-product-img">
                  <a :href="getImage(data.item)">
                    <img class="w-100 h-100" :src="getImage(data.item)" />
                  </a>
                </div>
              </template>
              <template v-slot:cell(title)="data">
                <span style="width: 300px">
                  <span style="line-height: 2">{{
                    data.item.product.title
                  }}</span>
                  <span v-if="data.item.color || data.item.attributes != ''">
                    <span> | </span>
                    <span v-if="data.item.color">
                      رنگ : {{ data.item.color.name }}
                      {{ data.item.attributes != "" ? " | " : "" }}
                    </span>
                    <span v-if="data.item.attributes != ''">
                      <span v-for="(attr, index) in data.item.attributes" :key="index">
                        {{ attr.label + ": " + attr.pivot.value }}
                        {{
                          index != data.item.attributes.length - 1 ? " | " : ""
                        }}
                      </span>
                    </span>
                  </span>
                </span>
              </template>
              <template v-slot:cell(quantity)="data">
                <button type="button" class="border border-radius7 px-1 bg-none" @click="decrement(data.item)"
                  :disabled="data.item.quantity == 1 || disabled ? true : false">
                  <DashSvg />
                </button>
                <span class="px-2">{{ data.item.quantity }}</span>
                <button type="button" class="border border-radius7 px-1 bg-none" @click="increment(data.item)"
                  :disabled="disabled">
                  <PlusSvg />
                </button>
              </template>
              <template v-slot:cell(amount)="data">
                <b-form-input style="width: 80px" class="m-auto" :value="formatDisplay(data.item.final_price.amount)"
                  @input="onPriceInput($event, data.item.final_price)" />
              </template>

              <template v-slot:cell(discount_amount)="data">
                <span v-if="
                  data.item.final_price.discount_price &&
                  !editDiscount[data.item.id]
                ">
                  {{ data.item.final_price.discount_price }}
                </span>
                <b-form-input v-else style="width: 80px" class="m-auto"
                  :value="data.item.final_price.discount_price | priceinput"
                  @input="(value) => onDiscountInput(value, data.item)">
                </b-form-input>
                <!-- <b-form-input  
                  v-else  
                  style="width: 80px"  
                  class="m-auto"  
                  :value="data.item.final_price.discount_price | priceinput"  
                  @input="(value) => onDiscountInput(value, data.item)"  
                >  
                </b-form-input>   -->
              </template>
              <template v-slot:cell(flash)="data">
                {{
                  data.item.product && data.item.product.active_flash != ""
                    ? data.item.product.active_flash[0].title
                    : "ندارد"
                }}
              </template>
              <template v-slot:cell(total_price)="data">
                <span v-if="data.item.final_price.amount != 0">{{
                  (data.item.final_price.amount * data.item.quantity) | price
                }}</span>
                <span v-else>0</span>
              </template>
              <template v-slot:cell(seller_id)="data">
               
                <b-button @click="sellerModalHandler(data.item.id)">
                  <span>
                    {{
                      seller_ids[data.item.id] && seller_ids[data.item.id].label
                        ? seller_ids[data.item.id].label
                        : "انتخاب نشده"
                    }}
                  </span>
                  <i class="fa fa-angle-down"></i>
                </b-button>
              </template>
              <template v-slot:cell(delete)="data">
                <a class="action-btns1 pt-1 px-2" @click="deleteItem(data.item, i)">
                  <i class="feather feather-trash-2 text-danger"></i>
                </a>
              </template>
            </b-table>
          </div>
          <template v-if="varieties != '' || refund_varieties != ''">
            <div class="mt-5 col-md-5 mx-auto card justify-content-center little py-5 d-flex">
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> مجموع قیمت کالا ها : </span>
                <span class="px-3 py-2"> {{ total | price }} تومان </span>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> کدتخفیف دارد؟ </span>
                <form id="coupenCode" @submit.prevent="sendCoupen()" v-if="!coupenPrice">
                  <input type="text" placeholder="کد تخفیف" v-model="coupen" />
                  <input type="submit" value="ثبت" :class="{ disableCoupen: disableCoupen }" />
                </form>
                <p id="danger" v-else>
                  <span>
                    {{ coupenPrice | priceinput }}
                  </span>
                  <span> تومان </span>
                  <i @click="clearCoupon()" class="fa fa-trash text-danger"></i>
                </p>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> فاکتور باز : </span>
                <div class="px-3 py-2">
                  <input type="checkbox" v-model="isOpen" />
                </div>
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  مبلغ کارت به کارت (تومان):
                </span>
                <b-form-input style="width: 130px" :value="cardByCard_amount | priceinput" @input="
                  (value) => {
                    cardByCard_amount =
                      value !== '' ? +value.replace(/\D/g, '') : '';
                  }
                " />
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  مبلغ پرداخت نقدی (تومان):
                </span>
                <b-form-input style="width: 130px" :value="cash_amount | priceinput" @input="
                  (value) => {
                    cash_amount =
                      value !== '' ? +value.replace(/\D/g, '') : '';
                  }
                " />
              </div>
              <div v-if="
                customerInfo &&
                customerInfo.customer &&
                customerInfo.customer.wallet &&
                customerInfo.customer.wallet.balance && customerInfo.customer.wallet.balance > 0
              " class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold">
                  میزان کسر از کیف پول (تومان):
                </span>
                <b-form-input style="width: 130px" :value="walletB | priceinput" @input="
                  (value) => {
                    walletB = value !== '' ? +value.replace(/\D/g, '') : '';
                  }
                " />
              </div>
              <div class="d-md-flex justify-content-between">
                <span class="px-3 py-2 font-bold"> پرداخت از پوز (ریال): </span>
                <span class="px-3 py-2" :class="{
                  'text-success': totalPrice >= 0,
                  'text-danger': totalPrice < 0,
                }">
                  {{ (totalPrice * 10) | price }} ریال
                </span>
              </div>
            </div>
            <div class="row mt-4">
              <b-form-group class="col-md-6" label="یادداشت" :label-for="'description'">
                <b-form-textarea id="description" v-model="description" placeholder="یادداشت"
                  :required="isDiscountFilled" />
              </b-form-group>
            </div>
            <div class="mt-4 w-100 d-flex justify-content-center">
              <button type="submit " :disabled="DiasableSubmit" :class="{ reqDiasableStyle: DiasableSubmit }"
                class="btn btn-success">
                ثبت سفارش
              </button>
            </div>
          </template>
        </form>
      </div>
      <div id="selectSellerModal" @click="closeModal" v-if="showModal">
        <div id="selectSellerModalContainer">
          <div class="card">
            <div class="card-header border-0">
              <h5 class="card-title font-bold py-3">انتخاب فروشنده</h5>
              <div style="flex: 1"></div>
              <b-button variant="danger" @click="closeModal('close')">X</b-button>
            </div>
            <div class="card-body">
              <div id="selectSeller">
                <button v-for="(seller, index) in sellers" :key="index" class="sellerBtn" type="button"
                  @click="selectedSellerForVariety(seller)">
                  
                  {{ seller.label }}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </main>
</template>

<script>
import {
  BFormGroup,
  BFormInput,
  BTable,
  BButton,
  BFormCheckbox,
  BFormSelect,
  BFormTextarea,
} from "bootstrap-vue";
import PlusSvg from "@@/core/components/svgs/PlusSvg";
import DashSvg from "@@/core/components/svgs/DashSvg";
import Back from "@@/core/components/shared/Back/Back";
import ProductSearch from "@@/core/components/shared/ProductSearch/ProductSearch";

export default {
  name: "ShopCreate",
  components: {
    DashSvg,
    PlusSvg,
    BFormGroup,
    BFormInput,
    BFormSelect,
    BTable,
    BFormCheckbox,
    BFormTextarea,
    BButton,
    Back,
    ProductSearch,
  },
  data() {
    return {
      disabled: false,
      refund: false,
      selectedSeller: null,
      selectedSellerId: null,
      seller_ids: {},
      showModal: false,
      created_at: null,
      editDiscount: {},
      discountAmount: 0,
      cardByCard_amount: null,
      cash_amount: null,
      currentOrderItem: null,
      description: null,
      sendCoupenStatus: false,
      sellers: [],
      isOpen: 0,
      selectedVarietyId: null,
      productSku: "",
      reqDiasableStyle: true,
      customerMobile: "",
      varieties: [],
      refund_varieties: [],
      orderItems: [],
      firstName: "",
      lastName: "",
      customerInfo: null,
      admin: null,
      flag: true,
      coupenPrice: null,
      hasSelectedItem: false,
      tableKey: 0,
      walletB: null,
      coupen: null,
      disableCoupen: false,
      DiasableSubmit: false,
      
    };
  },
  computed: {
    isDiscountFilled() {
      if (
        this.totalPrice <= 0 &&
        this.cardByCard_amount <= 0 &&
        this.cash_amount <= 0
      ) {
        return true;
      } else {
        return false;
      }
    },
    isSellItem() {
      return this.varieties.length;
    },
    total() {
      return (
        this.varieties.reduce(
          (a, b) => a + b.final_price.amount * b.quantity,
          0
        ) -
        this.refund_varieties.reduce(
          (a, b) => a + b.final_price.amount * b.quantity,
          0
        )
      );
    },
    totalPrice() {
      let totalAmount = this.total - this.discountAmount;
      let walletBalance = 0;
      if (
        this.customerInfo &&
        this.customerInfo.customer &&
        this.customerInfo.customer.wallet &&
        this.customerInfo.customer.wallet.balance
      ) {
        walletBalance = this.customerInfo.customer.wallet.balance;
        if (this.walletB > walletBalance) {
          this.walletB = 0;
        }
      }
      if (this.cardByCard_amount > 0) {
        totalAmount -= this.cardByCard_amount;
      }
      if (this.cash_amount > 0) {
        totalAmount -= this.cash_amount;
      }
      if (this.coupenPrice && this.coupenPrice > 0) {
        totalAmount -= this.coupenPrice;
      }
      if (this.walletB > 0 && this.walletB < totalAmount) {
        totalAmount -= this.walletB;
      } else if (
        this.walletB >= totalAmount &&
        this.walletB > 0 &&
        !this.refund_varieties.length
      ) {
        this.walletB = totalAmount;
        totalAmount = 0;
      }

      return totalAmount;
    },
    sellerIds(){
      return this.seller_ids
    }
  },
  mounted() {
    this.listenForKeyPress();
    this.$nextTick(() => {
      const ms = this.$el.querySelector('.fix-multiselect .multiselect')
      if (ms) {
        const width = ms.getBoundingClientRect().width
        document.documentElement.style
          .setProperty('--multiselect-width', `${width}px`)
      }
    });
  },
  methods: {
    getFields(type) {
      const baseFields = [
        { key: "index", label: "ردیف" },
        { key: "barcode", label: "بارکد" },
        { key: "image", label: "تصویر" },
        { key: "title", label: "عنوان" },
        { key: "amount", label: "قیمت واحد (تومان)" },
        { key: "quantity", label: "تعداد" },
        // { key: "discount_amount", label: "تخفیف واحد (درصد)" },
        { key: "seller_id", label: "فروشنده" },
        { key: "flash", label: "کمپین" },
        { key: "total_price", label: "قیمت نهایی (تومان)" },
        { key: "delete", label: "حذف" },
      ];

      return baseFields;
    },
    async getData() {
      const responseSeller = await this.$axios.get(
        `admin/sellers?all=1&is_active=1`
      );
      this.sellers = responseSeller.data.data.sellers.map((s) => {
        s.label = `${s.full_name}`;
        return s;
      });
      if (this.sellers.length == 1) {
        this.selectedSellerFunc(this.sellers[0]);
      }
    },
    checkCoupon() {
      if (this.coupenPrice) {
        this.coupenPrice = null;
        this.$root.notify(
          "جهت محاسبه کد تخفیف آنرا مجددا وارد کنید",
          "warning"
        );
      }
    },
    onDiscountInput(value, item) {
      item.final_price.discount_price =
        value !== "" ? +value.replace(/\D/g, "") : "";
      this.$set(this.editDiscount, item.id, 1);
    },
    // async searchOrderInput(value, item) {
    //   this.currentOrderItems = [];
    //   if (value.length < 2) return;

    //   try {
    //     const response = await this.$axios.get("admin/mini_orders/" + value);
    //     const order = response.data.data.mini_order;

    //     if (order && order.mini_order_items) {
    // this.currentOrderItems = order.mini_order_items
    //   .filter(i => i.type === "sell")
    //   .map(i => {
    //     const spentPerUnit =
    //       i.quantity > 1
    //         ? Math.floor(i.spent_wallet / i.quantity)
    //         : i.spent_wallet;

    //     return {
    //       ...i,
    //       spent_wallet: spentPerUnit,
    //     };
    //   });
    //     }
    //   } catch (e) {
    //     console.error(e);
    //   }
    // },
    clearCoupon() {
      this.coupenPrice = null;
      this.coupen = "";
    },
    selectedSellerForVariety(seller) {
      this.$set(this.seller_ids, this.selectedVarietyId, {
    label: seller.label,
    id: seller.seller_id,
  });
      
      // this.seller_ids[this.selectedVarietyId] = {
      //   label: seller.label,
      //   id: seller.seller_id,
      // };
      
      this.closeModal("close");
    },
    selectVariety(variety) {
      console.log(variety, "variety");
      this.addVariety(variety);
    },
    async sendCoupen() {
      this.disableCoupen = true;
      const varieties = this.varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      const refund_varieties = this.refund_varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      try {
        let fd = new FormData();
        fd.append("code", this.coupen);
        let reqBody = {
          mobile: this.customerMobile,
          discount_amount: this.discountAmount,
          first_name: this.firstName,
          last_name: this.lastName,
          description: this.description,
          from_wallet_amount: this.from_wallet_amount,
          varieties,
          refund_varieties,
        };
        if (this.coupen) {
          reqBody.coupon_code = this.coupen;
        }
        const response = await this.$axios.post("admin/coupon/verify", reqBody);

        this.coupenPrice = response.data.data.discount.discount;
      } catch (error) {
        this.$root.notify(error);
      } finally {
        this.disableCoupen = false;
      }
    },
    listenForKeyPress() {
      document.removeEventListener("keyup", this.onKeyPress);
      document.addEventListener("keyup", this.onKeyPress);
    },
    onKeyPress(e) { },
    closeModal(e) {
      if (e == "close" || e.target.id == "selectSellerModal") {
        this.showModal = false;
      }
    },
    sellerModalHandler(id) {
      this.selectedVarietyId = id;
      this.showModal = true;
    },
    async requestProduct() {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/mini_orders/search", {
          params: {
            barcode: this.productSku,
            refund: this.refund,
          },
        });
        const variety = response.data.data.variety;
        this.addVariety(variety);
        this.productSku = "";
        if (this.coupenPrice) {
          this.coupenPrice = null;
          this.$root.notify(
            "جهت محاسبه کد تخفیف آنرا مجددا وارد کنید",
            "warning"
          );
        }
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.$nextTick(() => {
          this.$refs.productSku.focus();
        });
      }
    },
    addVariety(variety) {
      const mode = this.refund ? "refund_varieties" : "varieties";
      const alreadyAdded = this[mode].find((v) => {
        return v.id == variety.id;
      });
      if (alreadyAdded) {
        alreadyAdded.quantity++;
        this.$root.notify(
          "به تعداد محصول اضافه شد: " + alreadyAdded.quantity,
          "success"
        );
      } else {
        variety.quantity = 1;
        this[mode].push(variety);
        // this.seller_ids[variety.id] = this.selectedSeller
        //   ? { label: this.selectedSeller.label, id: this.selectedSeller.id }
        //   : {};
      }
      this.checkSeller(variety.id);
    },
    async checkSeller(varietyId) {
      try {
        this.disabled = true;
        const response = await this.$axios.get("admin/seller-requests-by-variety-id/" + varietyId);
        this.sellers = response.data.data.sellerRequests.map((s) => {
          s.label = `${s.seller.full_name}`;
          return s;
        });
        if (this.sellers.length == 1) {
          this.selectedSellerFunc(this.sellers[0].seller);
          this.selectedVarietyId=varietyId
          this.selectedSellerForVariety(this.sellers[0])
        }
      } catch (e) {
      } finally {
        this.disabled = false;
      }
    },
    selectedSellerFunc(seller) {
      this.selectedSellerId = seller.id;
      this.selectedSeller = seller;
    },
    getImage(variety) {
      if (variety.images != "") {
        return variety.images[0].url;
      }
      if (variety.product.images != "") {
        return variety.product.images[0].url;
      }
      return null;
    },
    decrement(variety) {
      if (variety.quantity === 0) {
        return;
      }
      variety.quantity--;
      this.checkCoupon();
    },
    increment(variety) {
      variety.quantity++;
      this.checkCoupon();
    },
    deleteItem(variety, mode) {
      this[mode] = this[mode].filter((v) => {
        return v.id !== variety.id;
      });
      this.checkCoupon();
    },
    formatDisplay(value) {
      if (!value) return ''
      return value.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
    },

    onPriceInput(value, price) {
      const numeric = value.replace(/\D/g, '')
      price.amount = numeric ? +numeric : 0
    },
    async requestCustomer(mobile) {
      if (mobile.length !== 11) return;
      try {
        this.disabled = true;
        const response = await this.$axios.get(
          "admin/mini_orders/customer-search",
          {
            params: {
              mobile,
            },
          }
        );
        this.disabled = false;
        const data = response.data.data;
        data.from_wallet_amount = data.from_wallet_amount || 0;
        this.customerInfo = data;
        this.walletB = this.customerInfo.customer?.wallet.balance;

        this.productSku = "";
      } catch (e) {
        this.$root.notify(e);
      }
    },
    clearCustomer() {
      this.customerInfo = null;
      this.walletB = 0;
      this.customerMobile = "";
    },
    async submit() {
      if (!this.validate()) {
        return;
      }
      const varieties = this.varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      const refund_varieties = this.refund_varieties.map((v) => {
        return {
          id: v.id,
          quantity: v.quantity,
          amount: v.final_price.amount,
        };
      });
      let fd = new FormData();
      if (this.created_at) {
        fd.append("created_at", this.created_at);
      }
      fd.append(
        "cardByCard_amount",
        this.cardByCard_amount ? this.cardByCard_amount : 0
      );

      fd.append("mobile", this.customerMobile);
      fd.append("cash_amount", this.cash_amount ? this.cash_amount : 0);
      fd.append(
        "discount_amount",
        Number(this.discountAmount) +
        Number(this.coupenPrice ? this.coupenPrice : 0)
      );
      fd.append("description", this.description);
      if (this.walletB) {
        fd.append("from_wallet_amount", this.walletB);
      } else if (this.walletB == 0) {
        fd.append("from_wallet_amount", 0);
      } else if (
        this.customerInfo &&
        this.customerInfo.customer &&
        this.customerInfo.customer.wallet
      ) {
        fd.append("from_wallet_amount", 0);
      }
      if (this.coupen) fd.append("coupon_code", this.coupen);
      fd.append("sendCouponIsActive", this.sendCoupenStatus ? 1 : 0);
      
      
      this.varieties.forEach((item, index) => {
        if (this.seller_ids[item.id] && this.seller_ids[item.id].id && this.seller_ids[item.id].id !== 'NaN') {
          fd.append(
            `varieties[${index}][seller_id]`,
            this.seller_ids[item.id] ? +this.seller_ids[item.id].id : null
          );
        }
        fd.append(`varieties[${index}][id]`, item.id);
        fd.append(`varieties[${index}][quantity]`, item.quantity);
        fd.append(`varieties[${index}][amount]`, item.final_price.amount);
      });
      this.refund_varieties.forEach((item, index) => {
        if (this.seller_ids[item.id] && this.seller_ids[item.id] !== 'NaN') {
          fd.append(
            `refund_varieties[${index}][seller_id]`,
            this.seller_ids[item.id] ? +this.seller_ids[item.id].id : null
          );
        }
        fd.append(`refund_varieties[${index}][id]`, item.id);
        fd.append(`refund_varieties[${index}][quantity]`, item.quantity);
        fd.append(
          `refund_varieties[${index}][amount]`,
          item.final_price.amount
        );
      });
      try {
        this.reqDiasableStyle = false;
        this.disabled = true;
        const response = await this.$axios.post("admin/mini_orders", fd);

        const miniOrder = response.data.data.mini_order;
        this.$root.notify(response.data.message, "success");
        this.$router.push(`/admin/shop/orders/${miniOrder.id}?print=1`);
      } catch (e) {
        this.$root.notify(e);
      } finally {
        this.disabled = false;
        this.reqDiasableStyle = true;
      }
    },
    rialRound(x) {
      return Math.round(x);
    },
    validate() {
      if (
        (!this.varieties || !this.varieties.length) &&
        !this.refund_varieties &&
        !this.refund_varieties.length
      ) {
        this.$root.warningNotify("حداقل انتخاب یک تنوع الزامی است");
        return false;
      }
      return true;
    },
  },
  watch: {
    discountAmount(newValue) {
      this.checkCoupon();
    },
  },
  // created() {
  //   this.getData();
  // },
};
</script>

<style scoped>
.table-responsive {
  height: auto;
}

.reqDiasableStyle {
  cursor: not-allowed;
  opacity: 0.5;
}

.order-product-img {
  max-width: 50px;
  margin: auto;
}

.table-title {
  font-weight: bold;
}
</style>
<style>
.admin-order table tr:has(span.active) {
  background: #007bff21;
}

.admin-order table tr:has(span.active):hover {
  background-color: #007bff21 !important;
  cursor: pointer;
}

.card.little.info {
  background: linear-gradient(30deg, #d2e8ff 0%, #d5e6fc 35%, #eaf5ff 100%);
}

.card.little.online {
  background: linear-gradient(30deg, #c8ffc8 0%, #c8ffc8 35%, #e0ffe0 100%);
}

.card.little.physical {
  background: linear-gradient(30deg, #ffffe3 0%, #ffffbc 35%, #ffffc5 100%);
}

.card.little .card-header {
  font-weight: bold;
}

form#coupenCode input[type="submit"] {
  background-color: #1d99ff;
  color: white;
}

form#coupenCode input {
  padding: 4px 8px;
  border: 2px solid #1d99ff;
}

.disableCoupen {
  opacity: 0.5;
  pointer-events: none;
  cursor: not-allowed;
}

button#sendCoupen {
  display: flex;
  align-items: center;
  gap: 8px;
}

button#sendCoupen input {
  transform: scale(1.5);
}

.btnprimary {
  color: #fff !important;
  background-color: #0075ff;
  border-color: #3366ff;
}

.btnprimary:hover {
  background-color: #0256b8;
}

.btnprimary:hover input[type="checkbox"] {
  accent-color: #0256b8;
}

div#selectSeller button:hover,
div#selectSeller button.active {
  transition: all 0.4s;
  background: #009eff;
  color: white;
}

div#selectSeller button {
  border: 1px solid grey;
  background: transparent;
  box-shadow: 0 0 4px #1122115e;
  padding: 4px;
  border-radius: 6px;
}

div#selectSeller {
  display: grid;
  grid-template-columns: repeat(6, 2fr);
  gap: 12px;
}

div#selectSeller button:hover,
div#selectSeller button.active {
  transition: all 0.4s;
  background: #009eff;
  color: white;
}

div#selectSeller button {
  border: 1px solid grey;
  background: transparent;
  box-shadow: 0 0 4px #1122115e;
  padding: 4px;
  border-radius: 6px;
}

div#selectSeller {
  display: grid;
  grid-template-columns: repeat(10, 4fr);
  gap: 8px;
}

.mt-3.admin-order.table-responsive.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store.id.price.barcode.product_id.order.max_number_purchases.created_at.updated_at.unique_attributes_key.images.user_images.quantity.final_price.attributes.product.store {
  overflow: visible;
}

div#selectSellerModal {
  position: fixed;
  inset: 0;
  background: #11221194;
  z-index: 10000;
}

div#selectSellerModalContainer {
  position: absolute;
  left: 50%;
  transform: translate(-50%, -50%);
  top: 50%;
}
</style>
